var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('b-card',{class:{
      'border-0': this.paymentIntent !== null
    },attrs:{"body-class":"text-center"}},[(_vm.errorMsg)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.successMsg)+" ")]),_vm._v(" Le traitement de votre paiement peut prendre plusieurs minutes. ")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }